import { LightningElement, api } from "lwc";
import { assignedSlotNames } from "common/slot";
import { createTrack } from "common/track";

class footerLinks extends LightningElement {
  @api columns = null;
  slots = "";
  track = createTrack(this);

  get _columns() {
    return this.columns.map((col) => {
      return Object.assign({}, col, {
        links: col.links.map((link) => {
          return Object.assign({}, link, {
            handleClick: this.handleLinkClick.bind(this, link),
          });
        }),
      });
    });
  }

  handleLinkClick(link) {
    // Keep for backwards compatbility
    this.dispatchEvent(
      new CustomEvent("link_click", {
        detail: link,
      })
    );
    this.track("link_clicked", {
      label: link.label,
    });
  }

  handleSlotChange() {
    this.slots = assignedSlotNames(this.template).join(" ");
  }
}

export default footerLinks;
